<template>
  <div>
    <div class="d-flex justify-space-between mb-3">
      <div>
        <div class="font-weight-bold font-size-15">Маршрути документа</div>
        <div class="d-flex ga-3">
          <div>
            <span class="text-disabled">Всього маршрутів: </span>
            <span class="font-weight-bold">{{ routes.length }}</span>
          </div>

          <div>
            <span class="text-disabled">Активний: </span>
            <span
              v-if="activeRoute"
              class="font-weight-bold text-blue-darken-3">
              {{ activeRoute.name }}
            </span>
            <span v-else class="text-disabled font-weight-bold">
              Не вказано
            </span>
          </div>
        </div>
      </div>
      <v-btn @click="routeCreate">
        <v-icon class="mr-2" icon="mdi-plus"></v-icon>
        <span>Новий маршрут</span>
      </v-btn>
    </div>
    <route-item
      v-for="docTypeRoute in routes"
      :key="docTypeRoute.id"
      class="mb-3"
      :doc-type-route="docTypeRoute"></route-item>

    <div v-if="activeRoute">
      <div class="d-flex justify-space-between ga-3 align-center mb-3">
        <div class="font-size-15">
          <span class="font-weight-bold mr-1">Етапи маршруту</span>
          <span class="text-disabled">({{ activeRoute.stages.length }})</span>
        </div>

        <v-btn @click="stageCreate">
          <v-icon class="mr-2" icon="mdi-plus"></v-icon>
          <span>Додати етап</span>
        </v-btn>
      </div>

      <div v-if="!activeRoute.stages.length" class="text-disabled text-center">
        Етапи відсутні
      </div>

      <route-stages
        :stages="activeRoute.stages"
        @stage-create="stageCreate"
        @stage-update="stageUpdate"
        @stage-delete="stageDelete($event)"
        @participant-create="
          stageParticipantCreate($event.stageId, $event.userId)
        "
        @participant-delete="
          stageParticipantDelete($event.stageId, $event.participantId)
        "></route-stages>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRoutes } from './routes'
import RouteItem from './RouteItem.vue'
import RouteStages from './RouteStages.vue'

defineOptions({
  name: 'Routes',
})

const {
  routes,
  routeCreate,
  activeRoute,
  stageCreate,
  stageUpdate,
  stageDelete,
  stageParticipantCreate,
  stageParticipantDelete,
} = useRoutes()
</script>
